module.exports = __webpack_public_path__ + "static/media/planeta6.934adace.png";